import Flow, { PATH as FLOW } from './HomeFlow'

export default { Flow }
export const PATH = { FLOW }
